import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('access_token') || null,
    name: '',
    email: '',
    scores: null,
    balance: null,
    rates: null,
    transactions: null,
    adminTransactions: null,
    userTransactions: null,
    adminGameTransactions: null,
    rewards: null,
    adminRewards: null,
    adminFeatures: null,
    isAdmin: false,
    giftPayBalance: null,
    paymentMethods: null,
    paymentAmounts: null,
  },
  mutations: {
    retrieveToken(state, token) {
      state.token = token;
    },
    destroyToken(state) {
      state.token = null;
    },
    setName(state, name) {
      state.name = name;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setScores(state, scores) {
      state.scores = scores;
    },
    setBalance(state, balance) {
      state.balance = balance;
    },
    setRates(state, rates) {
      state.rates = rates;
    },
    setGiftPayBalance(state, giftPayBalance) {
      state.giftPayBalance = giftPayBalance;
    },
    setTransactions(state, transactions) {
      state.transactions = transactions;
    },
    setAdminTransactions(state, adminTransactions) {
      state.adminTransactions = adminTransactions;
    },
    setuserTransactions(state, userTransactions) {
      state.userTransactions = userTransactions;
    },
    setAdminGameTransactions(state, adminGameTransactions) {
      state.adminGameTransactions = adminGameTransactions;
    },
    setRewards(state, rewards) {
      state.rewards = rewards;
    },
    setAdminRewards(state, adminRewards) {
      state.adminRewards = adminRewards;
    },
    setAdminFeatures(state, adminFeatures) {
      state.adminFeatures = adminFeatures;
    },
    setIsAdmin(state, isAdmin) {
      state.isAdmin = isAdmin;
    },
    setPaymentMethods(state, paymentMethods) {
      state.paymentMethods = paymentMethods;
    },
    setPaymentAmounts(state, paymentAmounts) {
      state.paymentAmounts = paymentAmounts;
    },
  },
  getters: {
    loggedIn(state) {
      return state.token !== null;
    },
    name(state) {
      return state.name;
    },
    email(state) {
      return state.email;
    },
    scores(state) {
      return state.scores;
    },
    balance(state) {
      return state.balance;
    },
    rates(state) {
      return state.rates;
    },
    giftPayBalance(state) {
      return state.giftPayBalance;
    },
    transactions(state) {
      return state.transactions;
    },
    adminTransactions(state) {
      return state.adminTransactions;
    },
    userTransactions(state) {
      return state.userTransactions;
    },
    adminGameTransactions(state) {
      return state.adminGameTransactions;
    },
    rewards(state) {
      return state.rewards;
    },
    adminRewards(state) {
      return state.adminRewards;
    },
    adminFeatures(state) {
      return state.adminFeatures;
    },
    isAdmin(state) {
      return state.isAdmin;
    },
    paymentMethods(state) {
      return state.paymentMethods;
    },
    paymentAmounts(state) {
      return state.paymentAmounts;
    },
  },
  actions: {
    register(context, data) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('register', {
          firstname: data.firstname,
          lastname: data.lastname,
          email: data.email,
          password: data.password,
          region: data.region
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        })
      })
    },
    destroyToken(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.post('logout').then(response => {
            localStorage.removeItem('access_token');
            context.commit('destroyToken');
            resolve(response);
          }).catch(error => {
            localStorage.removeItem('access_token');
            context.commit('destroyToken');
            reject(error);
          })
        })
      }
    },
    retrieveToken(context, credentials) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('login', {
          username: credentials.username,
          password: credentials.password,
          otp: credentials.otp,
          backendlogin: credentials.backendlogin,
        }).then(response => {
          const token = response.data.access_token;
          localStorage.setItem('access_token', token);
          context.commit('retrieveToken', token);
          resolve(response);
        }).catch(error => {
          reject(error);
        })
      })
    },
    retrieveUserDetails(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('user').then(response => {
            const name = response.data.data.firstname + ' ' + response.data.data.lastname;
            const email = response.data.data.email;
            const isAdmin = response.data.data.role.toUpperCase() === 'ADMIN' ? true : false
            context.commit('setName', name);
            context.commit('setEmail', email);
            context.commit('setIsAdmin', isAdmin);
            resolve(response);
          }).catch(error => {
            context.commit('setName', '');
            context.commit('setEmail', '');
            context.commit('setIsAdmin', false);
            reject(error);
          })
        })
      }
    },
    retrieveScores(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('score/all').then(response => {
            const scores = response.data.data;
            context.commit('setScores', scores);
            resolve(response.data);
          }).catch(error => {
            context.commit('setScores');
            reject(error);
          })
        })
      }
    },
    retrieveBalance(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('bank/balance').then(response => {
            const balance = response.data.data.balance;
            context.commit('setBalance', balance);
            resolve(response.data);
          }).catch(error => {
            context.commit('setBalance');
            reject(error);
          })
        })
      }
    },
    retrieveRates(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('rates').then(response => {
            const rates = response.data.data;
            context.commit('setRates', rates);
            resolve(response.data);
          }).catch(error => {
            context.commit('setRates');
            reject(error);
          })
        })
      }
    },
    retrieveGiftPayBalance(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('rewards/admin/balance/all').then(response => {
            const giftPayBalance = response.data.data;
            context.commit('setGiftPayBalance', giftPayBalance);
            resolve(response.data);
          }).catch(error => {
            context.commit('setGiftPayBalance');
            reject(error);
          })
        })
      }
    },
    retrieveTransactions(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('bank/transactions').then(response => {
            const transactions = response.data.data;
            context.commit('setTransactions', transactions);
            resolve(response.data);
          }).catch(error => {
            context.commit('setTransactions');
            reject(error);
          })
        })
      }
    },
    retrieveAdminTransactions(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('bank/admin/transactions').then(response => {
            const adminTransactions = response.data.data;
            context.commit('setAdminTransactions', adminTransactions);
            resolve(response.data);
          }).catch(error => {
            context.commit('setAdminTransactions');
            reject(error);
          })
        })
      }
    },

    retrieveuserTransactions(context,data) {
      console.log("Store "+data.app_type);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('bank/user/transactions/'+data.userid+'/'+data.app_type).then(response => {
            const userTransactions = response.data.data;
            context.commit('setuserTransactions', userTransactions);
            resolve(response.data);
          }).catch(error => {
            context.commit('setuserTransactions');
            reject(error);
          })
        })
      }
    },
    retrieveAdminGameTransactions(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        
       
        return new Promise((resolve, reject) => {
          Vue.axios.get('game/admin/transactions').then(response => {
            const adminGameTransactions = response.data.data;
            context.commit('setAdminGameTransactions', adminGameTransactions);
            resolve(response.data);
          }).catch(error => {
            context.commit('setAdminGameTransactions');
            reject(error);
          })
        })
      }
    },
    retrieveRewards(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('rewards').then(response => {
            const rewards = response.data.data;
            context.commit('setRewards', rewards);
            resolve(response.data);
          }).catch(error => {
            context.commit('setRewards');
            reject(error);
          })
        })
      }
    },
    retrieveAdminRewards(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('rewards/admin').then(response => {
            const adminRewards= response.data.data;
            context.commit('setAdminRewards', adminRewards);
            resolve(response.data);
          }).catch(error => {
            context.commit('setAdminRewards');
            reject(error);
          })
        })
      }
    },
    retrieveAdminFeatures(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('features').then(response => {
            const features= response.data.data;
            context.commit('setAdminFeatures', features);
            resolve(response.data);
          }).catch(error => {
            context.commit('setAdminFeatures');
            reject(error);
          })
        })
      }
    },
    retrievePaymentMethods(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('bank/stripe/payment_methods').then(response => {
            const paymentMethods= response.data.data;
            context.commit('setPaymentMethods', paymentMethods);
            resolve(response.data);
          }).catch(error => {
            context.commit('setPaymentMethods');
            reject(error);
          })
        })
      }
    },
    retrievePaymentAmounts(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('bank/stripe/valid_payment_amounts').then(response => {
            const paymentAmounts= response.data.data;
            context.commit('setPaymentAmounts', paymentAmounts);
            resolve(response.data);
          }).catch(error => {
            context.commit('setPaymentAmounts');
            reject(error);
          })
        })
      }
    },
    getdisableQuestionsList(context){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('last200').then(response => {
            resolve(response.data);
          }).catch(error => {
            reject(error);
          })
        })
      }  
    },
    getUsersList(context,data){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('users?'+data.paramters).then(response => {
            resolve(response.data);
          }).catch(error => {
            reject(error);
          })
        })
      }
    },
    getQuestionsList(context,data){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('questionlist?'+data.paramters).then(response => {
            resolve(response.data);
          }).catch(error => {
            reject(error);
          })
        })
      }
    },  
    updateQuestionStatus(context,data){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          var difficulty = data.difficulty ? data.difficulty : '';
          Vue.axios.post('updatequestion/'+data.id,
           {
               "difficulty": difficulty
           }).then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      } 
    },
    updatebot(context,data){
      axios.defaults.headers.common['Content-Type'] = 'multipart/form-data';
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          
        
        Vue.axios.post('updateuser',data, { headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      } 
    },
    updateInbank(context,data){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
        Vue.axios.post('add-payment-by-admin',
            {
               "add_user_id":data.add_user_id,
               "amount":data.amount,
               "type":data.type,
               "otp":data.otp
           }).then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      } 
    },
    getMyData(context,data){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
        Vue.axios.post('send-two-way',
            {
               "add_amount_userid":data.userid,
               
           }).then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      } 
    },
    getOtp(){
      return new Promise((resolve, reject) => {
        Vue.axios.get('sendloginotp').then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
       
    },
    blockedUser(context,data){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
        Vue.axios.post('block-user-by-admin',
            {
               "block_user_id":data.add_user_id,               
           }).then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      } 
    },
    updateQuestion(context,data){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          var difficulty = data.difficulty ? data.difficulty : '';
          Vue.axios.post('updatequestion/'+data.id,
            {
               "question":data.question,
               "option_a":data.optiona,
               "option_b":data.optionb,
               "option_c":data.optionc,
               "option_d":data.optiond,
               "correct_answer":data.answer,
               "difficulty": difficulty
           }).then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      } 
    },
    getQuestionCategories(context){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('categorylist').then(response => {
            resolve(response.data);
          }).catch(error => {
            reject(error);
          })
        })
      }
    },
    unableQuestion(context,data){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        
        return new Promise((resolve, reject) => {
          Vue.axios.post('unablequestions',
            {
               "data": data.data
            }).then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      } 
    },
    getBotUsers(context){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('get-bot-users').then(response => {
            resolve(response.data);
          }).catch(error => {
            reject(error);
          })
        })
      }
    },
    getAllDamnnSites(context){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('get-all-damnn-sites').then(response => {
            resolve(response.data);
          }).catch(error => {
            reject(error);
          })
        })
      }
    },
    assignBots(context,data){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        
        return new Promise((resolve, reject) => {
          Vue.axios.post('assign-bots',
            {
               "data": data
            }).then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      } 
    }
  },
  modules: {
  }
})
